<template>
    <div class="my-orders">
        <h3 class="mb-3" >Affiliates</h3>
        <b-table striped :items="affiliates" :fields="fields">
            <template v-slot:cell(totalsales)="data">
                {{ totalSales(data.item) | currency }}
            </template>
            <template v-slot:cell(name)="data">
                {{ data.item.first_name }} {{ data.item.last_name }}
            </template>
            <template v-slot:cell(more)="data">
                <div style='white-space: nowrap;'>
                    <font-awesome-icon fixed-width class='text-success' v-if="data.item.banner_comment" :icon="['fad', 'check']" v-b-tooltip.hover title='Has changed affiliate page' />
                    <font-awesome-icon fixed-width class='text-danger' v-else :icon="['fad', 'times']" v-b-tooltip.hover title='Has not changed affiliate page' />
                    <a class='ml-3' :href="customURL(data.item.linkcode)">
                        <font-awesome-icon fixed-width :icon="['fad', 'external-link-alt']" />
                    </a>
                </div>
            </template>
            <template v-slot:cell(email)="data">
                {{ data.item.user.email }}
            </template>
            <template v-slot:cell(totalcredit)="data">
                {{ totalCredit(data.item) | currency }}
            </template>
        </b-table>
    </div>
</template>

<style lang="scss" scoped>
</style>

<script>

export default {
    data: () => ({
        busy: false,
        affiliates: [],
        fields: [
            {
                key: 'name',
                sortable: true,
                label: 'Name'
            },
            {
                key: 'email',
                label: 'Email'
            },
            {
                key: 'totalcredit',
                label: 'Current Credit'
            },
            {
                key: 'totalsales',
                label: 'Total Sales'
            },
            {
                key: 'more',
                label: 'More'
            }
        ]
    }),
    computed: {

    },
    methods: {
        customURL(url) {
            return window.location.origin + "/t/" + url
        },
        totalSales(item) {
            let total = 0;
            for(let t of item.transactions) {
                total += t.sale_amount*1
            }
            return total
        },
        totalCredit(item) {
            let total = 0;
            for(let t of item.transactions) {
                total += t.credit_amount*1
            }
            return total
        },
        fetchAffiliates () {
            this.busy = true
            this.$http({
                'url': 'dashboard/affiliate/list',
                'method': 'GET',
            }).then((response) => {
                this.busy = false
                this.affiliates = response.data.result
            }).catch((error) => {
                this.busy = false
                this.$swal({
                    toast: true,
                    html: 'Whoops, something went wrong.',
                    type: 'error',
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                })               
            })
        },
    },
    mounted () {
        this.fetchAffiliates();
    },
}
</script>
